import ids from '@iris-platform/ids-js-sdk';
import { resolver } from '../util';
import config from '../../config';
import getToken from '../../util/getToken';
import {
  handleHttpErrors,
  RequestFailureError,
  UnknownResponseError,
} from '../errors';

function getTime(time) {
  const dateLimit = new Date();
  if (time === 'day') {
    dateLimit.setDate(dateLimit.getDate() - 1);
  } else if (time === 'three_day') {
    dateLimit.setDate(dateLimit.getDate() - 3);
  } else {
    dateLimit.setDate(dateLimit.getDate() - 7);
  }
  return dateLimit.toISOString();
}

const getHealthServices = resolver.authenticatedResolver.createResolver(
  async () => {
    const servToken = await getToken('reports');
    const dateLimit = new Date();
    dateLimit.setDate(dateLimit.getDate() - 1);
    return ids
      .queryObjects({
        url: config.idsServiceUrl,
        token: servToken,
        className: 'historicalHealthData',
        userId: 'historical_health_check_reports',
        query: {
          env: 'sdk',
          time_bucket: { $gte: dateLimit },
        },
        sort: { time_bucket: -1 },
      })
      .then((response) => {
        const uniqueServices = new Set();
        if (response !== '') {
          response.forEach((element) => {
            uniqueServices.add(element.servertype);
          });
        }
        return [...uniqueServices];
      })
      .catch((error) => {
        if (error.response) {
          return handleHttpErrors(error);
        }
        if (error.request) {
          throw new RequestFailureError();
        } else {
          throw new UnknownResponseError();
        }
      });
  },
);

const getHealth = resolver.authenticatedResolver.createResolver(
  async (root, { envn, server, time }) => {
    const servToken = await getToken('reports');
    const dateLimit = getTime(time);
    return ids
      .queryObjects({
        url: config.idsServiceUrl,
        token: servToken,
        className: 'historicalHealthData',
        userId: 'historical_health_check_reports',
        query: {
          env: envn,
          servertype: server,
          avg: { $ne: 1 },
          time_bucket: { $gte: dateLimit },
        },
        sort: { time_bucket: 1 },
        skip: 0,
      })
      .then((response) => {
        const health = [];
        if (response !== '') {
          response.forEach((element) => {
            health.push(element);
          });
        }
        return health;
      })
      .catch((error) => {
        if (error.response) {
          return handleHttpErrors(error);
        }
        if (error.request) {
          throw new RequestFailureError();
        } else {
          throw new UnknownResponseError();
        }
      });
  },
);

const getCallServicesHealth = resolver.authenticatedResolver.createResolver(
  async () => {
    const servToken = await getToken('reports');
    const dateLimit = new Date();
    dateLimit.setDate(dateLimit.getDate() - 1);
    const services = config.callServices;
    return ids
      .queryObjects({
        url: config.idsServiceUrl,
        token: servToken,
        className: 'historicalHealthData',
        userId: 'historical_health_check_reports',
        query: {
          env: 'sdk',
          avg: { $ne: 1 },
          servertype: { $in: services },
          time_bucket: { $gte: dateLimit },
        },
        sort: { time_bucket: -1 },
      })
      .then((response) => {
        const badHealth = [];
        if (response !== '') {
          response.forEach((element) => {
            badHealth.push(element);
          });
        }
        return badHealth;
      })
      .catch((error) => {
        if (error.response) {
          return handleHttpErrors(error);
        }
        if (error.request) {
          throw new RequestFailureError();
        } else {
          throw new UnknownResponseError();
        }
      });
  },
);

export default {
  Query: {
    getHealth,
    getHealthServices,
    getCallServicesHealth,
  },
};
